import videojs, { VideoJsPlayer } from 'video.js';

const VideoJsButtonClass = videojs.getComponent('MenuButton');
const VideoJsMenuClass = videojs.getComponent('Menu');
const VideoJsComponent = videojs.getComponent('Component');
const Dom = videojs.dom;

/**
 * Convert string to title case.
 *
 * @param {string} string - the string to convert
 * @return {string} the returned titlecase string
 */
function toTitleCase(str: string): string {
	if (typeof str !== 'string') {
		return str;
	}

	return str.charAt(0).toUpperCase() + str.slice(1);
}

/**
 * Extend vjs button class for quality button.
 */
export default class ConcreteButton extends VideoJsButtonClass {
	items: any[] = [];
	hideThreshold_: number = 0;

	/**
	 * Button constructor.
	 *
	 * @param {Player} player - videojs player instance
	 */
	constructor(player: VideoJsPlayer) {
		super(player, { title: player.localize('Quality') });
	}

	/**
	 * Creates button items.
	 *
	 * @return {Array} - Button items
	 */
	createItems(): Array<any> {
		return [];
	}

	/**
	 * Create the menu and add all items to it.
	 *
	 * @return {Menu}
	 *         The constructed menu
	 */
	createMenu(): any {
		const menu = new VideoJsMenuClass(this.player_, { menuButton: this });

		this.hideThreshold_ = 0;

		// Add a title list item to the top
		if (this.options_.title) {
			const titleEl = Dom.createEl('li', {
				className: 'vjs-menu-title',
				innerHTML: toTitleCase(this.options_.title),
				tabIndex: -1
			});
			const titleComponent = new VideoJsComponent(this.player_, { el: titleEl } as any);

			this.hideThreshold_ += 1;

			menu.addItem(titleComponent as any);
		}

		this.items = this.createItems();

		if (this.items) {
			// Add menu items to the menu
			for (let i = 0; i < this.items.length; i++) {
				menu.addItem(this.items[i]);
			}
		}

		return menu;
	}
}
